import ICustomFormSettings from "../../ICustomFormSettings";
import m, {Vnode, VnodeDOM} from "mithril";
import RTMCard from "../RTMCard";
import RTM from "../RTM";
import {Answer} from "../RTMCard";
import $ from "jquery";

export default class RTMGuide extends RTM
{
    private readonly cardAgree: RTMCard;
    private readonly cardDisagree: RTMCard;

    private agreeAnswer: Answer|null = null;
    private disagreeAnswer: Answer|null = null;
    private agreeFinished: boolean = false;
    private disagreeFinished: boolean =  false;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        const questionary = settings.form.questionary;


        this.cardAgree = new RTMCard(
            questionary.messages.get('swipeRight'),
            this.onAgreeAnswer.bind(this),
            this.onAgreeFinish.bind(this),
            this.settings.form.questionary,
            {allowNegative: false, cardClass: "swipe.right"}
        );

        this.cardDisagree = new RTMCard(
            questionary.messages.get('swipeLeft'),
            this.onDisagreeAnswer.bind(this),
            this.onDisagreeFinish.bind(this),
            this.settings.form.questionary,
            {allowPositive: false, cardClass: "swipe.left"}
        );

    }

    checkRequirements(): boolean {
        return true;
    }

    public view(): Vnode {
        return this.viewLayout(
            this.getContent(),
            this.viewControls(this.disagreeFinished ? "gotIt" : "skip")
        );
    }

    private getContent(): any[] {
        const questionary = this.settings.form.questionary;
        const hint = this.settings.form.hint ? this.settings.form.hint : questionary.messages.get('ifYouAgreeSwipeRightDisagreeSwipeLeft');
        const header = this.settings.app.header;

        if (!this.agreeFinished) {
            header.hint = hint;
            return [
                m(this.cardAgree),
            ]
        } else if (!this.disagreeFinished) {
            header.hint = hint;
            return [
                m(this.cardDisagree),
            ]
        } else {
            header.hint = '';
            return [
                this.viewHintBar(),
                m(".finish-guide.fade-in", {
                    oncreate: () => $(window).trigger('resize'),
                }, [
                    m("p", {}, [m("i.icon.success.icon-success")]),
                    m("p", {}, questionary.renderText( questionary.messages.get('awesomeYouFinishGuide')) ),
                    m("p", {}, m.trust(questionary.renderText( questionary.messages.get('pressGotItToContinue'))) ),
                ]
            )];
        }
    }


    onAgreeAnswer(answer: Answer|null) {
        this.agreeAnswer = answer;
    }

    onDisagreeAnswer(answer: Answer|null) {
        this.disagreeAnswer = answer;
    }

    onAgreeFinish() {
        this.agreeFinished = this.agreeAnswer === "positive";
        m.redraw();
    }

    onDisagreeFinish() {
        this.disagreeFinished = this.disagreeAnswer === "negative";
        m.redraw();
    }


    private onKeydown(e:KeyboardEvent) {
        if (e.code === 'Space') {
            e.preventDefault();
            this.settings.nextForm();
            m.redraw();
        }
    }

    public oninit(vnode: VnodeDOM): void {
        // @ts-ignore
        $(document).on('keydown', this.onKeydown.bind(this));
    }

    public onremove(): void {
        $(document).off('keydown');
        $(document).off('keyup');
        this.settings.app.header.hint = null;
    }
}
